import { divIcon } from 'leaflet';
import React, { useEffect, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Marker, Popup, /* Tooltip */ } from 'react-leaflet';
import 'resources/styles/components/widgets/map.scss';

interface TooltipModalProps {
  latitude: number;
  longitude: number;
  content: any;
}

export default function TooltipModal(props: TooltipModalProps) {
  const markerRef: any = useRef();

  useEffect(() => {
    setTimeout(() => {
      markerRef.current && markerRef.current.openPopup();
    }, 100);
  }, []);

  return (
    <Marker
      ref={markerRef}
      position={[props?.latitude, props?.longitude]}
      icon={divIcon({ html: ReactDOMServer.renderToString(<div></div>)})}
    >

      <Popup
        className='tooltipModal'
        closeButton={false}
      >
        {props.content}
      </Popup>
    </Marker>
  );
}
